import { MergeDataset } from '../../decorators/decorators/merge.dataset';
import { MergeSource } from '../../decorators/decorators/merge.source';
import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { DocumentTheme } from '../../../../entities/document.themes/document.theme';
import { DocumentThemeQuoteOptions } from '../../../../entities/document.themes/document.theme.quote.options';
import { CompanyMergeData, CompanyMergeSchema } from '../data/company.merge.data';
import { EmployeeMergeData, EmployeeMergeSchema } from '../data/employee.merge.data';
import { QuoteProMergeSchema, QuoteProMergeData } from '../data/quote.pro.merge.data';
import { AccountMergeSchema, AccountMergeData } from '../data/account.merge.data';
import { AccountContactMergeData, AccountContactMergeSchema } from '../data/account.contact.merge.data';
import { BasicSiteMergeSchema, BasicSiteMergeData } from '../data/basic.site.merge.data';

@MergeDataset({
    entity: ActivityEntityName.QuotePro,
    dependsOn: [ActivityEntityName.Job, ActivityEntityName.Opportunity]
})
@MergeDataset({
    entity: ActivityEntityName.Quote,
    dependsOn: [ActivityEntityName.Job, ActivityEntityName.Opportunity]
})
export class QuoteProMergeDataset {

    @MergeSource({
        schema: QuoteProMergeSchema
    })
    quote: QuoteProMergeData;

    @MergeSource({
        schema: EmployeeMergeSchema
    })
    quoteOwner: EmployeeMergeData;

    @MergeSource({
        schema: CompanyMergeSchema
    })
    quoteCompany: CompanyMergeData;

    @MergeSource({
        schema: AccountMergeSchema
    })
    quoteAccount: AccountMergeData;

    @MergeSource({
        schema: BasicSiteMergeSchema
    })
    quoteSite: BasicSiteMergeData;

    @MergeSource({
        schema: AccountContactMergeSchema
    })
    quoteContact: AccountContactMergeData;

    theme: DocumentTheme<DocumentThemeQuoteOptions>;

    public static get empty() {
        return {
            quote: new QuoteProMergeData(),
            quoteOwner: new EmployeeMergeData(),
            quoteContact: new AccountContactMergeData(),
            quoteAccount: new AccountMergeData(),
            quoteSite: new BasicSiteMergeData(),
            quoteCompany: new CompanyMergeData(),
            theme: null
        } as QuoteProMergeDataset;
    }
}